// extracted by extract-css-chunks-webpack-plugin
module.exports = {"pre-wrap":"_3-to_p"};